import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// import { isArray } from 'lodash';
import toast from 'react-hot-toast';
import searchIcon from 'assets/images/icons/search.svg';
import { CallAPI } from 'actions/General';
import AlertModal from 'components/common-components/AlertModal';
import FormButton from 'components/form-components/FormButton';
import FormLoadingButton from 'components/form-components/FormLoadingButton';
import SingleCheckBoxField from 'components/form-components/SingleCheckBoxField';
import TextField from 'components/form-components/TextField';

const PowerBIViewModal = ({ handleClose, powerBIFormIds, refreshList }) => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState('');
  const [allList, setAllList] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchFormsList = async () => {
    const result = await CallAPI(
      'FETCH_META_DATA',
      { type: 'form_meta_and_sql', limit: 1000 },
      null,
    );
    if (result.status) {
      const list = result.data.rows
        .filter((item) => item.dbConnection && item.dbName)
        .map((item) => ({ id: item.formId, name: item.formTitle, dbName: item.dbName }));

      setAllList(list);
      setSelectedIds([...powerBIFormIds]);
    } else {
      toast.error(result.error);
    }
  };

  const toggleItem = (id) => {
    setSelectedIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const filteredSelected = allList.filter(
    (item) =>
      selectedIds.includes(item.id) && item.name.toLowerCase().includes(searchText.toLowerCase()),
  );

  const filteredUnselected = allList.filter(
    (item) =>
      !selectedIds.includes(item.id) && item.name.toLowerCase().includes(searchText.toLowerCase()),
  );

  const handleSubmit = async () => {
    const payload = {
      powerBiFunctionSetting: {
        forms: allList
          .filter((item) => selectedIds.includes(item.id))
          .map((item) => ({
            formId: item.id,
            verticalTableName: item.dbName,
          })),
      },
    };

    const result = await CallAPI('UPDATE_COMPANY_SQL_SETTINGS', payload, null, setLoading);
    if (result.status) {
      refreshList();
      handleClose();
    } else {
      toast.error(result.error);
    }
  };

  useEffect(() => {
    fetchFormsList();
  }, []);

  return (
    <AlertModal show={true} actionButtons={[]} noPadding>
      <div className='w-100'>
        <div className='d-flex px-4 py-3 border-bottom-grey-10-h-1'>
          <label className='theme-size-1_5 theme-font-inter-medium theme-text-black-1'>
            {t('text_bi_views')}
          </label>
        </div>

        <div className='px-4 mt-2'>{t('text_selected_forms_will_appear_in_postgres')}</div>

        <div className='px-4 py-3'>
          <TextField
            value={searchText}
            name='search'
            handleChange={(_, value) => setSearchText(value)}
            placeholder='field_search'
            icon={searchIcon}
            shrink
            classes='w-100'
          />

          <div className='mt-3 w-100 d-flex gap-4'>
            <div className='w-100' style={{ maxHeight: 'min(50vh, 22rem)', overflow: 'auto' }}>
              <label className='text-uppercase fw-bold'>{t('text_selected_forms')}</label>
              <div className='d-flex flex-column gap-2 my-2'>
                {filteredSelected.map((u) => (
                  <SingleCheckBoxField
                    key={u.id}
                    name={`selected-${u.id}`}
                    value={true}
                    handleChange={() => toggleItem(u.id)}
                    text={<span className='theme-size-0_9'>{u.name}</span>}
                    shrink
                  />
                ))}
              </div>

              <label className='text-uppercase fw-bold'>{t('text_forms')}</label>
              <div className='d-flex flex-column gap-2 my-2'>
                {filteredUnselected.map((u) => (
                  <SingleCheckBoxField
                    key={u.id}
                    name={`unselected-${u.id}`}
                    value={false}
                    handleChange={() => toggleItem(u.id)}
                    text={<span className='theme-size-0_9'>{u.name}</span>}
                    shrink
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex gap-2 justify-content-end p-3 border-top-grey-10-h-1'>
          <FormButton text='Cancel' variant='white-1' onClick={handleClose} />
          <FormLoadingButton
            onClick={handleSubmit}
            text='Save'
            variant='green-1'
            loading={loading}
            disabled={allList.length === 0}
          />
        </div>
      </div>
    </AlertModal>
  );
};

PowerBIViewModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  powerBIFormIds: PropTypes.array.isRequired,
  refreshList: PropTypes.func.isRequired,
};

export default PowerBIViewModal;
